<script setup lang="ts">
import { RouterLink } from 'vue-router';
import type { Product } from '../api';
import { text } from '../i18n';

defineProps<{ product: Product; index?: number }>();
</script>

<template>
  <article class="product-card">
    <RouterLink
      class="product-card__media"
      :to="`/products/${product.slug}`"
    >
      <img
        v-if="product.media[0]"
        :src="product.media[0].url"
        :alt="product.media[0].alt"
        loading="lazy"
      >
      <div
        v-else
        class="media-placeholder"
      >
        JWS
      </div>
      <span v-if="index !== undefined">{{ String(index + 1).padStart(2, '0') }}</span>
    </RouterLink>
    <div class="product-card__body">
      <small>{{ product.category.name }}</small>
      <h3>
        <RouterLink :to="`/products/${product.slug}`">
          {{ product.name }}
        </RouterLink>
      </h3>
      <p>{{ product.summary }}</p>
      <RouterLink
        class="text-link"
        :to="`/products/${product.slug}`"
      >
        {{ text('查看产品', 'View product') }} <b>→</b>
      </RouterLink>
    </div>
  </article>
</template>
